import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import { initSentry } from '@/lib/sentry';
import { initZodLocale } from '@/lib/zod-locale';
// Inter variable, la misma fuente de Effetá Apps: se sirve desde el bundle,
// sin depender de que el equipo tenga Inter instalada.
import '@fontsource-variable/inter';
import '@/styles/globals.css';

// Constante de compilación: en el build de producción vale `false` y Vite
// elimina el import del demo, que no llega al sitio publicado.
const isDemo = import.meta.env.VITE_USE_MSW === 'true';

async function enableMocking(): Promise<void> {
  if (isDemo) {
    // Modo demo (`pnpm dev:demo`): back simulado en el navegador, ver `src/demo/`.
    const { worker } = await import('@/demo/browser');
    await worker.start({ onUnhandledRequest: 'bypass', quiet: true });
    return;
  }
  // MSW deshabilitado: desregistrar SW residual de visitas previas
  // donde MSW estuvo activo. Sin esto, el SW antiguo sigue interceptando
  // requests al backend real (causa típica de "CORS error" fantasma).
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations
        .filter((r) => r.active?.scriptURL.includes('mockServiceWorker'))
        .map((r) => r.unregister()),
    );
  }
}

// Sentry primero para capturar errores de mocking/boot también.
initSentry();
initZodLocale();
await enableMocking();

const DemoBadge = isDemo ? (await import('@/demo/DemoBadge')).DemoBadge : null;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    {DemoBadge ? <DemoBadge /> : null}
  </React.StrictMode>,
);
